<div style="min-width: 330px; padding: 20px" fxLayout="column" fxLayoutAlign="center">
  <span style="text-align: right; margin-bottom: 10px;">
    @if (showJump) {
      <button mat-flat-button routerLink="/scheduler/editor" color="accent">
        <mat-icon>link</mat-icon>
        {{'general.jumpToSchedulers' | transloco}}
      </button>
    }
  </span>

  <div style="padding: 15px">
    <form [formGroup]="formScheduleProps">
      <div fxLayout="column">
        <mat-form-field fxFlex="column">
          <mat-label>{{'general.schedulerName' | transloco}}</mat-label>
          <input inputrestriction="basic1" matInput type="text" class="longInput form-control" placeholder="" required formControlName="schedule_name">
          @if (scheduleName.invalid || scheduleName.hasError('whitespace')) {
            <mat-error>please enter a valid schedule name</mat-error>
          }
        </mat-form-field>

        <mat-form-field class="full-width textarea">
          <mat-label>{{'placeholder.description' | transloco}}</mat-label>
          <textarea rows="8" matInput appearance="fill"
            inputrestriction="basic1"
            formControlName="description"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="8"
          cdkAutosizeMaxRows="8"></textarea>
        </mat-form-field>
      </div>
    </form>
  </div>

  <div fxFlex fxLayoutAlign="center center" fxLayoutGap="32px">
    <button mat-raised-button color="warn" (click)="onCreate()" [disabled]="!scheduleName.value">
<!--      @if (!editMode) {-->
<!--        <mat-icon>add_circle_outline</mat-icon>-->
<!--      }-->
      @if (!editMode) {
        <span>{{'general.create' | transloco}}</span>
      }
      @if (editMode) {
        <span>{{'general.update' | transloco}}</span>
      }
    </button>
    <button mat-raised-button color="primary" (click)="onClose()">{{'general.cancel' | transloco}}</button>
  </div>
</div>
